export default __webpack_public_path__ + "56ecd13b287db5377373f0d1a14eb29a.png";